<template>
  <div>
    <button class="trans-btn" @click="openModal">
      <img class="trans-icon"  src="/src/assets/icons/translate.svg" />
    </button>
    <ModalLang
        @selectLang="selectLang"
        v-show="isModalVisible"
        :translations="translations"
        :scope-lang="locale"
        @close="closeModal"
        @validate="validateModal"
    />
  </div>
</template>

<script>
import ModalLang from "./form/ModalLang.vue";
import ScopeService from "../modules/scope/ScopeService.js";

export default {
  name: 'GroupTranslator',
  props: ['lang', 'translations', 'locale'],
  components: {ModalLang},
  data: function () {
    return {
      isModalVisible: false,
      selectedLang: '',
    }
  },
  methods: {
    openModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
    translateAll(lang) {
      const translations = this.translations
      const currentTranslations = translations[this.selectedLang]

      Object.entries(currentTranslations).forEach((entry) => {
        const [key, value] = entry
        if (value !== null && value !== undefined) {
          ScopeService.getTranslation(value, this.selectedLang, lang).then((val) => {
            translations[lang][key] = val.data
          })
        }
      })


    },
    validateModal() {
      if (this.locale === 'all') {
        const translations = this.translations
        const filter = Object.keys(translations).filter((locale) => { return !locale.includes(this.locale)})
        filter.forEach((lang) => {
          this.translateAll(lang)
        })
      } else {
        this.translateAll(this.locale)
      }

      this.isModalVisible = false;
    },
    selectLang(lang) {
      this.selectedLang = lang
    }
  },

}
</script>
<style scoped>
.trans-btn {
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.25s ease-in-out;
}

.trans-icon {
  height: auto;
  width: 1.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/GroupTranslator.vue